<template>
  <div class='main'>
    <div class='menuContainer' :style="`width:${isHidden ? '0' : '221px'}`">
      <div class='hiddenIcon' @click='hiddenTab'>
        <i :class="isHidden ? 'el-icon-caret-right' : 'el-icon-caret-left'" style='color:#fff' />
      </div>
      <el-menu :default-active='pathActive' text-color='#335483' active-text-color='#fff' :unique-opened='true'
        style='width: 221px' :style="`transform:translateX(${isHidden ? '-221px' : '0'});transition: all .3s;`"
        @select='selectMenu' router>
        <el-submenu index='/vehicle/year' v-has="'pc_plan_manage'">
          <template slot='title' v-has="'pc_plan_manage'">
            <i class='el-icon-s-order' style='color:#335483' />
            <span>计划管理</span>
          </template>
          <!--          v-has="'pc_year_plan_manage'"-->
          <el-menu-item-group v-has="''">
            <el-menu-item index='/vehicle/yearMonthPlan'>年月计划</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_ship_settlement_river_plan'">
            <el-menu-item index='/vehicle/commercialCarPlan'>商品车计划</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_plan_year'">
            <el-menu-item index='/vehicle/year'>年月计划管理</el-menu-item>
          </el-menu-item-group>
          <!--          v-has="'pc_prediction_plan'"-->
          <el-menu-item-group v-has="'pc_plan_prediction'">
            <el-menu-item index='/vehicle/forecast'>预报计划</el-menu-item>
          </el-menu-item-group>
          <!--          v-has="'pc_transport_plan'"-->
          <el-menu-item-group v-has="'pc_plan_transport'">
            <el-menu-item index='/vehicle/transport'>运输计划</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_interface_plan'">
            <el-menu-item index='/vehicle/importPlan'>接口运输计划</el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group v-has="'pc_interface_plan'">
            <el-menu-item index="/vehicle/completePlan">完善运输计划</el-menu-item>
          </el-menu-item-group> -->


        </el-submenu>
        <el-submenu index='/vehicle/storageRoom' v-has="'pc_storeroom_manage'">
          <template slot='title' v-has="'pc_storeroom_manage'">
            <i class='el-icon-s-home' style='color:#335483' />
            <span>库房管理</span>
          </template>
          <el-menu-item-group v-has="'pc_storeroom_detail'">
            <el-menu-item index='/vehicle/storageRoom'>库房管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_cost_portAndWarehouse'">
            <el-menu-item index='/vehicle/portWarehouseCharges'>港口库房费用</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/vehicle/task' v-has="'pc_highway_transport'">
          <template slot='title'>
            <i class='el-icon-receiving' style='color:#335483;font-weight: 700' />
            <span>公路运输管理</span>
          </template>
          <el-menu-item-group v-has="'pc_vehicle_deployment'">
            <el-menu-item index='/vehicle/carmanage'>车辆调配管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_driver_loading_manage'">
            <el-menu-item index='/vehicle/driverManage'>司机装车管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_highway_car_statistic'">
            <el-menu-item index='/vehicle/highwayStat'>公路在途委托车统计</el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group v-has="'pc_highway_task'">
            <el-menu-item index="/vehicle/task">任务管理(公路)</el-menu-item>
          </el-menu-item-group> -->
          <el-menu-item-group v-has="'pc_highway_scan_code'">
            <el-menu-item index='/vehicle/sweepyard'>扫码装车</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_delivery'">
            <el-menu-item index='/vehicle/management'>交车管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_change_board'">
            <el-menu-item index='/vehicle/board'>换板管理</el-menu-item>
          </el-menu-item-group>
          <!--            <el-menu-item-group>-->
          <!--              <el-menu-item index="/vehicle/cost">费用报销</el-menu-item>-->
          <!--            </el-menu-item-group>-->
        </el-submenu>
        <el-submenu index='/vehicle/voyage' v-has="'pc_waterway_transport'">
          <template slot='title'>
            <i class='el-icon-help' style='color:#335483;font-weight: 700' />
            <!--            <img alt="" :src="require('@/assets/images/ship.png')" style="width: 18px;height: 18px;margin-right: 6px;object-fit: cover;margin-left: 4px;">-->
            <span>水路运输管理</span>
          </template>
          <el-menu-item-group v-has="'pc_ship_deployment'">
            <el-menu-item index='/vehicle/shipmanage'>船舶调配管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_waterway_car_statistic'">
            <el-menu-item index='/vehicle/waterStat'>水路在途委托车统计</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_voyage_number_manage'">
            <el-menu-item index='/vehicle/voyage'>航次管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_waterway_task'">
            <el-menu-item index='/vehicle/shipment'>港口调配管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_loading_unloading'">
            <el-menu-item index='/vehicle/scanning'>装卸管理</el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group>-->
          <!--            <el-menu-item index="/vehicle/discharging">卸船任务管理</el-menu-item>-->
          <!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_transfer_ship'">
            <el-menu-item index='/vehicle/overside'>过驳管理</el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group v-has="'pc_change_ship'">-->
          <!--            <el-menu-item index="/vehicle/transshipment">转船管理</el-menu-item>-->
          <!--          </el-menu-item-group>-->
          <!--          <el-menu-item-group>-->
          <!--            <el-menu-item index="/vehicle/lock">过闸管理</el-menu-item>-->
          <!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_stop_ship'">
            <el-menu-item index='/vehicle/specialships'>特殊停船管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_ship_operation_info'">
            <el-menu-item index='/vehicle/shipRunningDynamicTable'>船舶运行动态表</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!--        <el-submenu index="/vehicle/inbound" >-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-shop" style="color:#335483"/>-->
        <!--            <span>仓库管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item index="/vehicle/inbound">入库管理</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item index="/vehicle/outbound">出库管理</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item index="/vehicle/dispatch">出库调配车辆</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--        v-has="'pc_way_information'"-->
        <el-submenu index='/vehicle/car' v-has="'pc_on_the_way'">
          <template slot='title' v-has="'pc_on_the_way'">
            <i class='el-icon-s-promotion' style='color:#335483' />
            <span>在途信息</span>
          </template>
          <el-menu-item-group v-has="'pc_port_focus_manage'">
            <el-menu-item index='/vehicle/port'>集港管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_mass_report'">
            <el-menu-item index='/vehicle/car'>委托车跟踪</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_highway_track'">
            <el-menu-item index='/vehicle/team'>公路跟踪</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_waterway_track'">
            <el-menu-item index='/vehicle/ship'>水路跟踪</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_ship_track'">
            <el-menu-item index='/vehicle/shipTracking'>船舶跟踪</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/vehicle/report' v-has="'pc_mass_loss'">
          <template slot='title' v-has="'pc_mass_loss'">
            <i class='el-icon-s-management' style='color:#335483' />
            <span>质损管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/vehicle/report' v-has="'pc_line_set_report'">质损上报</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/vehicle/qualityLossList' v-has="'pc_mass_loss_list'">质损列表
            </el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group >-->
          <!--            <el-menu-item index="/vehicle/audit" v-has="'pc_mass_examine'">质损审核</el-menu-item>-->
          <!--          </el-menu-item-group>-->
        </el-submenu>
        <el-submenu index='/vehicle/statisticalAnalysisOfBrandTraffic' v-has="'pc_statistics_report'">
          <template slot='title'>
            <i class='el-icon-data-analysis' style='color:#335483' />
            <span>统计分析报表</span>
          </template>
          <el-menu-item-group v-has="'pc_brand_transport_report'">
            <el-menu-item index='/vehicle/statisticalAnalysisOfBrandTraffic'>品牌运量统计分析
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_brand_transport_shipping'">
            <el-menu-item index='/vehicle/shippingStatistics'>发运统计报表</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_operation_records_shipping'">
            <el-menu-item index='/vehicle/operateRecordReport'>操作记录统计报表</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_gathering_port_information_shipping'">
            <el-menu-item index='/vehicle/portInformation'>集港信息统计</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_sporadic_vehicle_shipping'">
            <el-menu-item index='/vehicle/pickupTruckInformation'>零星车统计报表</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/vehicle/line' v-has="'pc_logistics_configure'">
          <template slot='title' v-has="'pc_logistics_configure'">
            <i class='el-icon-location' style='color:#335483' />
            <span>物流配置</span>
          </template>
          <el-menu-item-group v-has="'pc_line_configure'">
            <el-menu-item index='/vehicle/line'>线路设置</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/vehicle/Devops' v-has="'pc_operate_manage'">
          <template slot='title' v-has="'pc_operate_manage'">
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>运维管理</span>
          </template>
          <el-menu-item-group v-has="'pc_operate_detail'">
            <el-menu-item index='/vehicle/Devops'>运维管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_operate_detail'">
            <el-menu-item index='/vehicle/Cache'>缓存数据异常表</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_cams_transfer_manage'">
            <el-menu-item index='/vehicle/transmissionManagement'>长安民生传输管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_electronic_fence'">
            <el-menu-item index='/vehicle/electronicFence'>电子围栏管理模块</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/vehicle/change' v-has="'pc_change_manage'">
          <template slot='title' >
            <i class='el-icon-edit' style='color:#335483' />
            <span>变更管理</span>
          </template>
          <el-menu-item-group v-has="'pc_change_manage'">
            <el-menu-item index='/vehicle/changeManagement'>变更管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class='content2' :style="`width:${isHidden ? '100%' : 'calc(100% - 221px)'}`"
      style='background-color: rgb(244, 247, 251);'>
      <router-view v-if="$route.path.split('/').length >= 3" style='background-color: rgb(244, 247, 251);' />
      <Home v-else />
      <div class='footer-div'>渝ICP备2022002327号-1</div>
    </div>
  </div>
</template>

<script>
import Home from '@/views/home/main';

export default {
  components: {
    Home,
  },

  data() {
    return {
      pathActive: null,
      activeNum: 1,
      isHidden: false,
    };
  },
  watch: {
    $route(to, from) {
      this.pathActive = this.$route.path;
    },
  },
  mounted() {
    this.pathActive = this.$route.path;
  },
  methods: {
    hiddenTab() {
      this.isHidden = !this.isHidden;
    },
    selectMenu() {
      this.activeNum = 0;
    },
  },
};
</script>


<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;

  .menuContainer {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: relative;
    transition: all .3s;
    height: calc(100vh - 70px);
    overflow-x: hidden;

    .hiddenIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #48599E;
      width: 11px;
      height: 50px;
      position: absolute;
      top: calc(50% - 20px);
      right: -11px;
      border-radius: 0 10px 10px 0;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .content {
    width: calc(100% - 221px);
    height: calc(100vh - 70px);
    overflow: auto;
  }

  .content2 {
    transition: all .3s;
    width: 100%;
    height: calc(100vh - 70px);
    overflow: auto;
  }

  ::v-deep {
    .el-menu-item.is-active {
      background-color: #335483;
    }

    .el-menu-item:focus {
      outline: 0;
      background-color: #335483;
    }
  }

  .content2>.contract-list,
  .content2>.electrify,
  .content2>.operation,
  .content2>.consignSettle,
  .content2>.portSettle,
  .content2>.stockpile,
  .content2>.warehouse,
  .content2>.deferlnvoicing,
  .content2>.massLoss-list,
  .content2>.logisticsConfig,
  .content2>.finance-income,
  .content2>.price-highway,
  .content2>.main,
  .content2>.supplierTrain,
  .content2>.otherFees,
  .content2>.mainContainer {
    height: calc(100% - 30px);
    overflow-y: auto;
  }

  .footer-div {
    display: block;
    position: relative;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 13px;
    color: #a8a8a8;
    background-color: #f4f7fb;
  }
}
</style>
